module.exports = __webpack_public_path__ + "media/stylesheets/images/Kazuki Fukutoku-2d0db086d6b790ff423a4c483137af1e.jpg";